export var SIDE_BAR_HEADINGS;
(function(SIDE_BAR_HEADINGS) {
    SIDE_BAR_HEADINGS["DEFAULT"] = "DEFAULT";
    SIDE_BAR_HEADINGS["SETTINGS"] = "SETTINGS";
})(SIDE_BAR_HEADINGS || (SIDE_BAR_HEADINGS = {}));
